<template>
  <div>
    <div v-if="loading" class="loading-page">
      <div class="resultsLoader">
        <img src="../static/loader.png" alt="טעינה" />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data: () => ({
    loading: false,
    timer:null
  }),
  methods: {
    start() {
      this.loading = true
    },
    finish() {
        this.loading = false
    }
  },
}
</script>

<style scoped lang="scss">
.loading-page {
  background-color: #fff;
  position: fixed;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 8000;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
}

/* results loading */
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.resultsLoader {
  display: flex;
  justify-content: center;
  margin-top: 76px;
  margin-bottom: 85px;
}

.resultsLoader img {
  animation: spin 2s infinite linear;
}
</style>
